__webpack_require__.p = "https://dsr-internal.integration.mindtickle.com/";